import { isDecryptedPayload, } from '@standardnotes/models';
import { KeyRecoveryStrings } from '@standardnotes/encryption';
import { ChallengePrompt } from '../Challenge/Prompt/ChallengePrompt';
import { ChallengeReason } from '../Challenge/Types/ChallengeReason';
import { ChallengeValidation } from '../Challenge/Types/ChallengeValidation';
export async function DecryptItemsKeyWithUserFallback(itemsKey, encryptor, challengor) {
    const decryptionResult = await encryptor.decryptSplitSingle({
        usesRootKeyWithKeyLookup: {
            items: [itemsKey],
        },
    });
    if (isDecryptedPayload(decryptionResult)) {
        return decryptionResult;
    }
    const secondDecryptionResult = await DecryptItemsKeyByPromptingUser(itemsKey, encryptor, challengor);
    if (secondDecryptionResult === 'aborted' || secondDecryptionResult === 'failed') {
        return secondDecryptionResult;
    }
    return secondDecryptionResult.decryptedKey;
}
export async function DecryptItemsKeyByPromptingUser(itemsKey, encryptor, challengor, keyParams) {
    if (!keyParams) {
        keyParams = encryptor.getKeyEmbeddedKeyParamsFromItemsKey(itemsKey);
    }
    if (!keyParams) {
        return 'failed';
    }
    const challenge = challengor.createChallenge([new ChallengePrompt(ChallengeValidation.None, undefined, undefined, true)], ChallengeReason.Custom, true, KeyRecoveryStrings.KeyRecoveryLoginFlowPrompt(keyParams), KeyRecoveryStrings.KeyRecoveryPasswordRequired);
    const response = await challengor.promptForChallengeResponse(challenge);
    if (!response) {
        return 'aborted';
    }
    const password = response.values[0].value;
    const rootKey = await encryptor.computeRootKey(password, keyParams);
    const secondDecryptionResult = await encryptor.decryptSplitSingle({
        usesRootKey: {
            items: [itemsKey],
            key: rootKey,
        },
    });
    challengor.completeChallenge(challenge);
    if (isDecryptedPayload(secondDecryptionResult)) {
        return { decryptedKey: secondDecryptionResult, rootKey };
    }
    return 'failed';
}
